import React, { useState, useRef, Fragment, useEffect } from "react";
import useInfiniteScroll from "../../helpers/useInfiniteScroll";
import { history } from "../../helpers/history";
import transactionObj from "../../services/transaction.service";
import DateFormat from "../../helpers/DateFormat";
import crossImgs from "../../assets/images/icons/cross.svg";
import RefreshToken from "../../helpers/RefreshToken";
import ReactDatePickerHelper from "../../helpers/ReactDatePickerHelper";
import ExportToExcel from "../superadmin/ExportToExcel";
import DialoguePopup from "../../helpers/DialoguePopup";
import BoLoader from "../../helpers/BoLoader";
import GetAllClients from "../../helpers/GetAllClients";

const PAGE_SIZE = 20;

const SearchGridInputData = [
  {
    TokenId: "",
    ClientId: "",
    Status: "",
    DateFrom: "",
    DateTo: "",
  },
];

var fontStyle = {
  textTransform: "uppercase",
};

const PendingCloseCardsGrid = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [tokenId, setTokenId] = useState("");
  const [status, setStatus] = useState("");
  const searchTbl = useRef();
  const [loadingData, setLoadingData] = useState(false);
  const [SearchInputDisabled, setSearchDisabled] = useState(false);
  const [, setClientIdVal] = useState("");
  const [classContent] = useState("tab-content");

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  // getpendingclosedcard takes no filters and returns the whole list, so the
  // full response is held here and the filters below are applied in the
  // browser. `visibleCount` is what infinite scroll grows.
  const [allCards, setAllCards] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [searchGridSuccess, setSearchGridSuccess] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  //Dialouge Popup Error Messages
  const [modalShowDialouge, setModalShowDialouge] = useState(false);
  const [modelhdng, setMdlHdng] = useState("");
  const [MdlIcon, setMdlIcon] = useState("");
  const [modelbdy, setMdlBdy] = useState("");

  const [boloader, setBoLoader] = useState(false);

  // Export states (same pattern as Negative Balance)
  const [dataset, setDataset] = useState([]);
  const [isExcelDownload, setiisExcelDownload] = useState(false);

  const errorAndSuccessModl = (heading, body, Icon) => {
    setModalShowDialouge(true);
    setMdlHdng(heading);
    setMdlBdy(body);
    setMdlIcon(Icon);
  };

  useEffect(() => {
    LoadPendingCloseCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LoadPendingCloseCards = () => {
    setLoadingData(true);
    setSearchGridSuccess(false);

    transactionObj
      .getPendingClosedCards()
      .then((resp) => {
        setLoadingData(false);
        const payload = resp?.data?.payload || [];
        setAllCards(payload);
        applyFilters(payload);
      })
      .catch((error) => {
        setLoadingData(false);
        setSearchGridSuccess(false);
        setAllCards([]);
        setSearchData([]);
        setTotalCount(0);

        (async () => {
          const resp = await RefreshToken(
            error && error.response && error.response.status
          );
          if (resp) {
            LoadPendingCloseCards();
          }
        })();
      });
  };

  const applyFilters = (source) => {
    const list = source || allCards;

    const tokenFilter = (SearchGridInputData[0].TokenId || "")
      .toString()
      .trim()
      .toLowerCase();
    const statusFilter = (SearchGridInputData[0].Status || "")
      .toString()
      .trim()
      .toLowerCase();
    const clientFilter = (SearchGridInputData[0].ClientId || "").toString();
    const from = SearchGridInputData[0].DateFrom
      ? new Date(SearchGridInputData[0].DateFrom)
      : null;
    const to = SearchGridInputData[0].DateTo
      ? new Date(SearchGridInputData[0].DateTo)
      : null;
    // the To date is inclusive of the whole day
    if (to) to.setHours(23, 59, 59, 999);

    const filtered = (list || []).filter((row) => {
      if (
        tokenFilter &&
        !(row.tokenId || "").toString().toLowerCase().includes(tokenFilter)
      )
        return false;

      if (
        statusFilter &&
        !(row.status || "").toString().toLowerCase().includes(statusFilter)
      )
        return false;

      if (clientFilter && (row.clientId || "").toString() !== clientFilter)
        return false;

      if (from || to) {
        const created = row.createdAt ? new Date(row.createdAt) : null;
        if (!created) return false;
        if (from && created < from) return false;
        if (to && created > to) return false;
      }

      return true;
    });

    // newest queued first
    const sortedData = filtered
      .slice()
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setSearchData(sortedData);
    setTotalCount(sortedData.length);
    setVisibleCount(PAGE_SIZE);
    setSearchGridSuccess(sortedData.length > 0);

    if (searchTbl.current) {
      searchTbl.current.onscroll = tblScrollHandler;
    }
  };

  const handleInputSearchClick = (e) => {
    e.preventDefault();
    setModalShow(true);
    setSearchDisabled(true);
  };

  const onChangeTokenId = (e) => {
    SearchGridInputData[0].TokenId = e.target.value;
    setTokenId(e.target.value);
  };

  const onChangeStatus = (e) => {
    SearchGridInputData[0].Status = e.target.value;
    setStatus(e.target.value);
  };

  const dateFilter = (date) => new Date(date);

  const dateFromHandler = (e) => {
    SearchGridInputData[0].DateFrom = e;
    if (e) SearchGridInputData[0].DateFrom = dateFilter(e);
    setDateFrom(SearchGridInputData[0].DateFrom);
  };

  const dateToHandler = (e) => {
    SearchGridInputData[0].DateTo = e;
    if (e) SearchGridInputData[0].DateTo = dateFilter(e);
    setDateTo(SearchGridInputData[0].DateTo);
  };

  const ClientNameChangeHandler = (e) => {
    const clientId = e.target.selectedOptions[0].value;
    SearchGridInputData[0].ClientId = clientId;
    setClientIdVal(clientId);
  };

  const SearchClickHandler = (e) => {
    if (e) e.preventDefault();
    setModalShow(false);
    setSearchDisabled(false);
    applyFilters();
  };

  const tblScrollHandler = () => {
    setVisibleCount((prev) => (prev < totalCount ? prev + PAGE_SIZE : prev));
  };

  // Sentinel-driven pagination — see helpers/useInfiniteScroll.js.
  // The onScroll/onWheel handlers only fire when the table element itself
  // scrolls; .table-wrap is overflow-x only and touch devices emit no wheel
  // event, so on mobile the list silently stopped loading.
  const infiniteScrollRef = useInfiniteScroll(
    tblScrollHandler,
    visibleCount < totalCount,
    false
  );

  const renderTableHeader = () => {
    let header = Object.values(props.headersdata);
    return header.map((key, index) => <th key={index}>{key.toUpperCase()}</th>);
  };

  const showCardHolderDetailPage = (id, userId, issuerCategory) => {
    history.push("/cardholderdetails", { id, userId, issuerCategory });
  };

  const renderTableData = () => {
    return (searchData || []).slice(0, visibleCount).map((data, index) => {
      const {
        tokenId,
        clientName,
        createdAt,
        userId,
        cardId,
        issuerCategory,
        balance,
        status,
        description,
      } = data;

      return (
        <tr key={index}>
          <td style={fontStyle}>{clientName}</td>
          <td>
            <span
              style={{ color: "#0d6efd", cursor: "pointer" }}
              title="View Card Holder Details"
              onClick={() =>
                showCardHolderDetailPage(cardId, userId, issuerCategory)
              }
            >
              {tokenId}
            </span>
          </td>
          <td style={fontStyle}>{balance}</td>
          <td style={fontStyle}>{status}</td>
          <td>{description}</td>
          <td>
            <DateFormat date={createdAt} />
          </td>
        </tr>
      );
    });
  };

  const HideSearchPopupDiv = () => {
    setModalShow(false);
    setSearchDisabled(false);
  };

  const ClearSearchData = () => {
    SearchGridInputData[0].TokenId = "";
    SearchGridInputData[0].Status = "";
    SearchGridInputData[0].ClientId = "";
    SearchGridInputData[0].DateFrom = "";
    SearchGridInputData[0].DateTo = "";

    setTokenId("");
    setStatus("");
    setClientIdVal("");
    setDateFrom("");
    setDateTo("");

    ClearInputData();
  };

  const ClearInputData = () => {
    if (document.getElementById("clientNameDD") !== null)
      document.getElementById("clientNameDD").value = "";

    setClientIdVal("");

    setTimeout(() => {
      [...document.getElementsByClassName("r-input-group")].forEach((element) => {
        element.children[0].value = "";
      });
      const btn = document.getElementById("searchBtnClients");
      if (btn) btn.click();
    }, 500);
  };

  // The whole filtered set is already in memory, so export needs no second
  // call — it just hands the current result to ExportToExcel.
  const showExcelModel = () => {
    if (!searchData || searchData.length === 0) {
      errorAndSuccessModl(
        "Error",
        "There is no data available to export.",
        "icon-error"
      );
      return;
    }
    setBoLoader(true);
    setDataset(searchData);
    setiisExcelDownload(true);
    setBoLoader(false);
  };

  const resetModal = () => {
    setiisExcelDownload(false);
    setDataset([]);
  };

  return (
    <div className="mt-0 mt-sm-4">
      <div className={classContent} id="myTabContent2">
        <BoLoader loading={boloader} />

        {/* Export UI row (same place/pattern as Negative Balance) */}
        <div className="row">
          <div className="col-sm-2 toRight ms-auto mt-sm-100 mt-4 mb-4">
            {isExcelDownload ? (
              <Fragment>
                <div>
                  <ExportToExcel
                    Dataset={dataset}
                    calledfrom="pendingclosecards"
                    Name={"PendingCloseCards"}
                  />
                  <button
                    id="searchBtnExportToExcel"
                    className="btn btn-large mt-3"
                    onClick={resetModal}
                  >
                    Reset
                  </button>
                </div>
              </Fragment>
            ) : (
              <button
                id="searchBtnExportToExcel"
                className="btn btn-large mr-19"
                onClick={showExcelModel}
              >
                Export
              </button>
            )}
          </div>
        </div>

        <div
          className="tab-pane fade show active"
          id="allClients"
          role="tabpanel"
          aria-labelledby="allClients-tab"
        >
          <Fragment>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="row row-search">
                <div className="col-xl-12 col-12">
                  <div className="form-group">
                    <div className="form-controls">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.placeholdervalue}
                        onClick={handleInputSearchClick}
                        disabled={SearchInputDisabled}
                      />
                      <span className="icon-search _ico"></span>

                      <div
                        className="bo-cardsearch"
                        style={{ display: modalShow ? "" : "none" }}
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="col-md-4">
                              <img
                                className="cross-icon cross-modal"
                                src={crossImgs}
                                aria-label="Close"
                                onClick={HideSearchPopupDiv}
                                alt=""
                              />
                            </div>
                            <div className=" col-md-12 form-group form-search mr-20">
                              <label>Token Id</label>
                              <div className="form-controls mr-20">
                                <input
                                  type="text"
                                  value={tokenId}
                                  onChange={onChangeTokenId}
                                  className="form-control"
                                  maxLength={20}
                                />
                              </div>
                            </div>
                          </div>

                          <div className=" col-md-6 form-group form-search">
                            <label>Status</label>
                            <div className="form-controls mr-20">
                              <input
                                type="text"
                                value={status}
                                onChange={onChangeStatus}
                                className="form-control"
                                maxLength={20}
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group form-search mr-20">
                              <label>Date From</label>
                              <div className="form-controls">
                                <ReactDatePickerHelper
                                  datevalue={dateFrom}
                                  onchangedate={dateFromHandler}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group form-search mr-20">
                              <label>Date To</label>
                              <div className="form-controls">
                                <ReactDatePickerHelper
                                  datevalue={dateTo}
                                  onchangedate={dateToHandler}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group form-search mr-20">
                              <label className="mb-24">Client Name</label>
                              <div className="form-controls">
                                <GetAllClients
                                  clientnamechangehandler={ClientNameChangeHandler}
                                  searchgriddata={"Y"}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group submit-field form-search">
                              <button
                                id="searchBtnClients"
                                className="btn btn-large mr-19"
                                onClick={SearchClickHandler}
                              >
                                Search
                              </button>
                              <button
                                className="btn btn-outline"
                                onClick={ClearSearchData}
                              >
                                Clear Search
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                    <span className="help-block d-none"></span>
                  </div>
                </div>
              </div>
            </form>
          </Fragment>
        </div>

        {searchGridSuccess && (
          <div className="table-wrap" ref={searchTbl}>
            <table
              className="table table-borderless bo-table table-cards"
              onScroll={tblScrollHandler}
              onWheel={tblScrollHandler}
            >
              <thead>
                <tr>{renderTableHeader()}</tr>
              </thead>
              <tbody>{renderTableData()}</tbody>
            </table>
            <div ref={infiniteScrollRef} aria-hidden="true" className="bopay-scroll-sentinel" />
          </div>
        )}

        {loadingData ? (
          <div className="loading-more">
            <div className="loader">
              <div></div>
            </div>
            <p>loading data</p>
          </div>
        ) : totalCount === 0 ? (
          <div className="d-flex align-content-center justify-content-center  no-clients-msg">
            <div className="text-center">
              <span className="icon-clients-empty">
                <span className="path1"></span><span className="path2"></span>
                <span className="path3"></span><span className="path4"></span>
                <span className="path5"></span><span className="path6"></span>
              </span>
              <h3>Empty Pending Close Card Listing</h3>
              <h6>There is no pending close card(s) available for now.</h6>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <DialoguePopup
        show={modalShowDialouge}
        onHide={() => setModalShowDialouge(false)}
        modelheading={modelhdng}
        modelbody={modelbdy}
        modelicon={MdlIcon}
      />
    </div>
  );
};

export default PendingCloseCardsGrid;
